<template>
	<v-layout>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text>
					<strong>

					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text>
					<strong>
						{{lp}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs5 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 5px; padding-right: 5px;">
					<strong>
						{{cost.description}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(costOfType(['z dotacji']))}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(costOfType([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe']))}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(costOfType(['odsetki', 'przychody']))}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(costOfType(['wkład rzeczowy']))}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(costOfType(['wkład osobowy']))}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../utils/Numbers";
	import {InvoiceComparisonResult} from "./Utils/InvoiceComparisonResult";

	export default {
		name: "FinalReportInvoicesSingleCostComparison",

		mixins: [Numbers],

		computed: {
			lp () {
				if (!this.lpPrefix) {
					return this.cost.serialNumber;
				} else {
					return this.lpPrefix + "." + this.cost.serialNumber;
				}
			},

			rowColor () {
				switch (this.invoiceType) {
					case InvoiceComparisonResult.added:
						return 'green lighten-3';
					case InvoiceComparisonResult.removed:
						return 'red lighten-3';
					case InvoiceComparisonResult.changed:
						return 'blue lighten-3';
					case InvoiceComparisonResult.changedOldVersion:
						return 'blue lighten-3';
					case InvoiceComparisonResult.changedNewVersion:
						return 'blue lighten-3';
					default:
						return 'grey lighten-2';
				}
			}
		},

		methods: {
			costOfType (types) {
				let result = 0;
				for (const division of this.cost.costDivisions) {
					if (types.indexOf(division.type) !== -1) {
						result += division.totalPrice;
					}
				}
				return result;
			},
		},

		props: {
			lpPrefix: {},
			cost: {},
			invoiceType: String
		}
	};
</script>

<style scoped>

</style>